<template>
  <div id="app">
    <!-- Удаляем видео-элемент -->
    <!-- <video autoplay muted loop playsinline class="background-video">
      <source src="@/assets/background.webm" type="video/webm">
    </video> -->

    <div class="roulette-container">
      <!-- Заменяем golden-frame на изображение -->
      <img src="@/assets/1_12.webp" alt="Заголовок" class="title-image">

      <div id="spin_the_wheel">
        <canvas id="wheel" ref="wheel"></canvas>

        <!-- Добавляем изображение барабана -->
        <div class="drum-container">
          <img
            src="@/assets/drum.webp"
            alt="Барабан"
            class="drum-image"
            ref="drumImage"
          />
        </div>

        <!-- Указатель стрелки, показывается до вращения -->
        <img
          src="@/assets/arrow.png"
          alt="Указатель"
          class="animated-arrow"
          v-if="!spinning"
        />

        <!-- Треугольник-указатель, показывается после начала вращения -->
        <div class="pointer" v-else></div>

        <!-- Центральная кнопка -->
        <div class="central-circle" @click="onSpinClick"></div>
      </div>

      <div class="lenta-wrapper">
        <img src="@/assets/lenta.webp" alt="Лента" class="lenta-image" />
      </div>
      <!-- Добавляем новый блок для отображения вращений -->
      <div class="spins-counter">
        <img src="@/assets/lentafake.webp" alt="Фон счетчика" class="spins-bg" />
        <div class="spins-overlay">
          <span class="vrash-label">ВРАЩЕНИя:</span>
          <span class="vrash-count">{{ userCount }}</span>
        </div>
      </div>
    </div>
    <div :class="['modal', { show: showModal, 'prize-modal': isPrizeSector }]">
      <div class="modal-content">
        <span class="close-btn" @click="closeModal">×</span>

        <!-- Добавляем отображение обычного текста -->
        <div v-if="!isPrizeSector" class="modal-message" v-html="modalText"></div>

        <!-- Контейнер для приза -->
        <div v-if="isPrizeSector" class="prize-container">
          <div class="prize-images-container">
            <img :src="require(`@/assets/${isOpenPrize ? 'priz_open.png' : 'priz.png'}`)"
                 alt="Приз"
                 :class="['prize-image', { 'shake': isShaking }]" />
            <img v-if="!isOpenPrize"
                 src="@/assets/odin.jpg"
                 alt="Дополнительное изображение"
                 class="additional-prize-image"
                 style="transform: rotate(-45deg);" />
          </div>

          <!-- Сообщения для разных сценариев -->
          <template v-if="isOpenPrize">
            <!-- Сообщение для VPN приза -->
            <p v-if="selectedVpn" class="prize-message success" v-html="selectedVpn"></p>
            <!-- Сообщение для обычного приза -->
            <template v-if="selectedPrize">
              <p class="prize-message collect" v-html="selectedPrize"></p>
            </template>
          </template>
        </div>

        <!-- Кнопки для приза -->
        <div class="buttons-container">
          <div v-if="isPrizeSector && !actionTaken" class="prize-buttons">
            <button
              class="collect-btn"
              @click="collectPrize"
              :disabled="actionTaken"
            >
              Забрать
            </button>
            <button
              class="prize-btn"
              @click="handlePrizeClick"
              :disabled="actionTaken"
            >
              Приз
            </button>
          </div>

          <!-- Кнопка написать после забрать -->
          <button
            v-if="showCollectMessage"
            class="contact-support-btn"
            @click="openSupportChat"
          >
            Написать
          </button>
        </div>

        <!-- Существующие кнопки -->
        <button
          v-if="exchangeSpinsCount && !isPrizeSector"
          class="exchange-btn"
          @click="exchangeSpins"
        >
          Обменять
        </button>
        <button
          v-if="showContactButton && !exchangeSpinsCount && !isPrizeSector"
          class="contact-btn"
          @click="openSupportChat"
        >
          Написать
        </button>
      </div>
    </div>
    <div id="fireworks-container" v-if="showFireworks"></div>
    <!-- Добавляем новое модальное окно для шкатулок -->
    <div :class="['modal', { show: showCaseModal }]" v-if="showCaseModal">
      <div class="modal-content case-modal">
        <span class="close-btn" @click="closeCaseModal">×</span>
        <h2 class="case-title" :class="{ 'empty-case': showEmptyText }">
          {{ showEmptyText ? 'Пусто!' : 'Выберите шкатулку' }}
        </h2>
        <p class="case-subtitle">В 1 из шкатулок находится 1.000₽</p>
        <div class="cases-container">
          <div
            v-for="(box, index) in boxes"
            :key="index"
            class="case-box"
            @click="selectCase(index)"
            :class="{ 'shake': box.isShaking }"
          >
            <img
              :src="require(`@/assets/${box.isOpen ? 'case_lose.png' : 'case.png'}`)"
              alt="Шкатулка"
              class="case-image"
            />
          </div>
        </div>
        <p v-if="showWinText" class="win-text">Приз ваш!</p>
      </div>
    </div>
  </div>
</template>

<script>
import initFireworks, { stopFireworks } from '@/utils/fireworks.js';
const sectorsData = [
  { label: 1, color: "#FF0000", text: "айфон 16", remainingCount: 184 },
  { label: 2, color: "#FFFFFF", text: "впн 1 день", remainingCount: 8 },
  { label: 3, color: "#FF0000", text: "2 500р", remainingCount: 25 },
  { label: 4, color: "#FFFFFF", text: "впн 5 дней", remainingCount: 8 },
  { label: 5, color: "#FF0000", text: "алиса", remainingCount: Infinity },
  { label: 6, color: "#FFFFFF", text: "впн 3 дня", remainingCount: 0 },
  { label: 7, color: "#FF0000", text: "5 000р", remainingCount: Infinity },
  { label: 8, color: "#FFFFFF", text: "впн 1 мес", remainingCount: 0 },
  { label: 9, color: "#FF0000", text: "10 000р", remainingCount: Infinity },
  { label: 10, color: "#FFFFFF", text: "впн 1 день", remainingCount: 5 },
  { label: 11, color: "#FF0000", text: "аирподс", remainingCount: 188 },
  { label: 12, color: "#FFFFFF", text: "шкатулка", remainingCount: 2 },
  { label: 13, color: "#FF0000", text: "эпл вотч", remainingCount: 184 },
  { label: 14, color: "#FFFFFF", text: "впн 5 дней", remainingCount: 2 },
  { label: 15, color: "#FF0000", text: "1 000р", remainingCount: 10 },
  { label: 16, color: "#FFFFFF", text: "впн 3 дня", remainingCount: 2 },
  { label: 17, color: "#FF0000", text: "100 000р", remainingCount: Infinity },
  { label: 18, color: "#FFFFFF", text: "впн год", remainingCount: 1 },
  { label: 19, color: "#FF0000", text: "пс 5", remainingCount: Infinity },
  { label: 20, color: "#FFFFFF", text: "впн 3 мес", remainingCount: 0 },
  { label: 21, color: "#FF0000", text: "впн 6мес", remainingCount: Infinity },
  { label: 22, color: "#FFFFFF", text: "впн 1мес", remainingCount: 2 },
  { label: 23, color: "#FF0000", text: "50 000р", remainingCount: 312 },
  { label: 24, color: "#FFFFFF", text: "Сектор прищ", remainingCount: 2 },
];

// Пример: усилили веса последних секторов
const probabilitiesData = [
  { range: [0, 1], weight: 8000 },  // Пустой сектор (увеличенный вес)
  { range: [1, 2], weight: 150 },    // VPN на год (уменьшено до 100)
  { range: [2, 3], weight: 450 },    // VPN на 3 месяца (уменьшено до 300)
  { range: [3, 4], weight: 300 },    // VPN на 6 месяцев (уменьшено до 200)
  { range: [4, 5], weight: 12000 },  // Пустой сектор (увеличенный вес)
  { range: [5, 6], weight: 1 },      // 50,000₽ (оставлено)
  { range: [6, 7], weight: 7000 },  // Пустой сектор (увеличенный вес)
  { range: [7, 8], weight: 0 },     // 2,500₽ (уменьшено до 10)
  { range: [8, 9], weight: 12000 },  // Пустой сектор (увеличенный вес)
  { range: [9, 10], weight: 25 },     // Колонка "Алиса" (уменьшено до 5)
  { range: [10, 11], weight: 1500 }, // Промокод на 5 дней (уменьшено до 1,000)
  { range: [11, 12], weight: 10 },    // 5,000₽ (уменьшено до 2)
  { range: [12, 13], weight: 4000},// Пустой сектор (увеличенный вес)
  { range: [13, 14], weight: 2 },    // 10,000₽ (оставлено)
  { range: [14, 15], weight: 1000 },  // VPN на 1 месяц (уменьшено до 800)
  { range: [15, 16], weight: 10 },    // AirPods (уменьшено до 5)
  { range: [16, 17], weight: 12000 },// Пустой сектор (увеличенный вес)
  { range: [17, 18], weight: 2 },    // AppleWatch (уменьшено до 2)
  { range: [18, 19], weight: 10000 },// Пустой сектор (увеличенный вес)
  { range: [19, 20], weight: 0 },   // 1,000₽ (уменьшено до 20)
  { range: [20, 21], weight: 0 },    // 100,000₽ (оставлено)
  { range: [21, 22], weight: 1 },    // 100,000₽ (оставлено)
  { range: [22, 23], weight: 3000 }, // Промокод на 3 дня (уменьшено до 3,000)
  { range: [23, 24], weight: 1 },    // iPhone 16 (оставлено)
];

export default {
  name: "App",
  data() {
    return {
      // Если нужно прятать страницу, когда не в Телеграме (мини-апп)
      showFireworks: false,
      isTelegram: false,
      showModal: false,
      modalText: "", // Текст модального окна
      showContactButton: false, // Управляет отображением кнопки "Написать"
      exchangeSpinsCount: null, // Количество вращений для обмена
      clickSound: null, // Переменная для звука


      spinning: false,
      sectors: sectorsData,
      probabilities: probabilitiesData,

      sparkles: Array.from({ length: 24 }, () => ({
        opacity: Math.random(),
        increasing: Math.random() > 0.5,
      })),
      glowRadius: 30,
      glowIncreasing: true,

      // Telegram Mini App user_id & count
      userId: null,
      userCount: 0,

      isPrizeSector: false,
      isOpenPrize: false,
      isShaking: false,
      actionTaken: false, // Флаг для отслеживания действия
      showCollectMessage: false, // Флаг для сообщения о выигрыше
      prizes: [
        'iPhone 16',
        'Apple Watch',
        'PS 5',
        '50.000₽'
      ],
      vpnPrizes: [
        'VPN на 1 месяц',
        'VPN на 3 месяца',
        'VPN на 6 месяцев'
      ],
      selectedPrize: null,
      selectedVpn: null,
      showCaseModal: false,
      boxes: [
        { isOpen: false, isShaking: false },
        { isOpen: false, isShaking: false }
      ],
      caseSelected: false,
      showEmptyText: false, // добавляем новое поле
      showWinText: false,
    };
  },

   mounted() {
    // Получаем user_id из Telegram WebApp
    if (window.Telegram && window.Telegram.WebApp) {
      this.userId = window.Telegram.WebApp.initDataUnsafe?.user?.id;
      console.log("Telegram user_id:", this.userId);
    } else {
      console.warn("Telegram WebApp not available");
    }

    // Если user_id получен, запрашиваем количество вращений
    if (this.userId) {
      this.fetchUserCount();
    }

    this.clickSound = new Audio(require('@/assets/click.mp3'));

    this.resizeCanvas();
    window.addEventListener("resize", this.resizeCanvas);
    this.animateGlow();
    this.animateSparkles();
    this.drawWheel();
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.resizeCanvas);
  },

  methods: {
    //------------------------------------------------------
    // Получаем кол-во вращений
    //------------------------------------------------------
    async fetchUserCount() {
      if (!this.userId) {
        console.error("User ID not available");
        return;
      }

      try {
        const url = `https://ctvpnkoleso.ru/api/user/${this.userId}/count`;
        console.log("Fetching user count from:", url);

        const res = await fetch(url);
        if (!res.ok) {
          console.error("Failed to fetch user count. Status:", res.status);
          this.userCount = 0;
          return;
        }

        const data = await res.json();
        console.log("User count response data:", data);

        this.userCount = data.count || 0;
      } catch (err) {
        console.error("Error in fetchUserCount:", err);
        this.userCount = 0;
      }
    },
    showModalWithText(text, showSupport = false, showFireworks = false, successMusic = false) {
      // Проверяем, является ли приз шкатулкой
      if (text.toLowerCase().includes('шкатулка')) {
        this.showCaseModal = true;
        return;
      }

      this.modalText = text;
      this.showContactButton = !!showSupport;
      this.showModal = true;

      // Проверяем, является ли выпавший сектор призовым
      this.isPrizeSector = text.toLowerCase().includes('сектор приз');
      this.isOpenPrize = false; // Сбрасываем состояние открытого приза
      this.actionTaken = false;
      this.showCollectMessage = false;

      if (showFireworks) {
        // Инициализируем фейерверк без звука
        initFireworks({ sound: false });

        setTimeout(() => {
          stopFireworks();
          this.showFireworks = false;
        }, 5000);
      }

      if (successMusic) {
        // Убираем воспроизведение звука
        // const successAudio = new Audio(require('@/assets/success.mp3'));
        // successAudio.play().catch((err) => {
        //   console.error("Ошибка воспроизведения success.mp3:", err);
        // });
      }
    },
    exchangeSpins() {
      if (!this.exchangeSpinsCount) return;

      this.addSpinsToUser(this.exchangeSpinsCount)
        .then(() => {
          this.closeModal(); // Закрываем модальное окно
          this.exchangeSpinsCount = null; // Сбрасываем значение
        })
        .catch((err) => {
          console.error("Ошибка при начислении вращений:", err);
        });
    },
    // Закрытие модального окна
    closeModal() {
        // Немедленно остановить фейерверки
        stopFireworks();

        // Скрыть модальное окно
        this.showModal = false;
        this.isPrizeSector = false;
        this.isOpenPrize = false;
        this.actionTaken = false;
        this.showCollectMessage = false;

        // Удалить классы после скрытия
        const modal = document.querySelector('.modal');
        modal.classList.remove('show', 'hide');

        // Обновить количество вращений
        this.fetchUserCount();
    },
    // Открытие чата в Telegram
    openSupportChat() {
      window.open("https://t.me/helpyourvpn", "_blank");
    },

    //------------------------------------------------------
    // Уменьшаем count у пользователя
    //------------------------------------------------------
    async decrementUserCount() {
      if (!this.userId) return;
      try {
        const url = `/api/user/${this.userId}/decrement`;
        const res = await fetch(url, {
          method: "POST",
          headers: {
            Authorization: process.env.VUE_APP_SECRET_PASSWORD,
          },
        });
        const data = await res.json();
        if (res.ok && data.new_count !== null && data.new_count !== undefined) {
          this.userCount = data.new_count;
        } else {
          this.userCount = 0;
        }
      } catch (err) {
        console.error("decrementUserCount error:", err);
      }
    },

    //------------------------------------------------------
    // Клик по центральному кругу
    //------------------------------------------------------
    async onSpinClick() {
      // Проверяем наличие user_id
      if (!this.userId) {
        this.showModalWithText("Ошибка: не удалось определить пользователя");
        return;
      }

      if (this.userCount <= 0) {
        const falseAudio = new Audio(require('@/assets/false.mp3'));
        falseAudio.play().catch((err) => {
          console.error("Ошибка воспроизведения false.mp3:", err);
        });
        this.modalText = "У вас закончились вращения! Приобретите новый ключ или продлите действующий."; // Добавляем текст в modalText
        this.showModal = true; // Показываем модальное окно
        return;
      }

      // Add proper error handling for the increment request
      try {
        const res = await fetch("https://ctvpnkoleso.ru/spins/increment", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Add any required authorization headers
            // "Authorization": "Bearer your-token-here"
          },
          body: JSON.stringify({ user_id: this.userId })
        });

        if (!res.ok) {
          console.error("Failed to increment spin count on server.");
          // Continue with spin anyway since this is not critical
        } else {
          const data = await res.json();
          console.log("Total spins incremented:", data.total_spins);
        }
      } catch (err) {
        console.error("Error incrementing spins on server:", err);
        // Continue with spin anyway since this is not critical
      }

      this.spinRoulette(); // Start the spin animation
    },

    //------------------------------------------------------
    // Настраиваем canvas под окно
    //------------------------------------------------------
    resizeCanvas() {
  const canvas = this.$refs.wheel;
  if (!canvas) return;

  const ctx = canvas.getContext("2d");

  // Рассчитываем, какой будет размер (CSS-пиксели)
  const size = Math.min(window.innerWidth * 0.9, window.innerHeight * 0.9);

  // Узнаём плотность пикселей
  const ratio = window.devicePixelRatio || 1;

  // Устанавливаем "визуальный" размер (как будет выглядеть на странице)
  canvas.style.width = size + "px";
  canvas.style.height = size + "px";

  // Устанавливаем реальный размер Canvas (в физических пикселях)
  canvas.width = size * ratio;
  canvas.height = size * ratio;

  // Масштабируем контекст, чтобы рисовать в нормальных координатах
  ctx.scale(ratio, ratio);

  // Перерисовываем колесо
  this.drawWheel();
},
    //------------------------------------------------------
    // Отрисовка колеса
    //------------------------------------------------------
   drawWheel() {
  const canvas = this.$refs.wheel;
  const ctx = canvas.getContext("2d");

  const size = parseFloat(canvas.style.width);
  const rad = size / 2;
  const arc = (2 * Math.PI) / this.sectors.length;

  ctx.clearRect(0, 0, canvas.width, canvas.height);

  this.sectors.forEach((sector, index) => {
    const startAngle = -Math.PI / 2 + index * arc;

    // Рисуем сектор
    ctx.beginPath();
    ctx.moveTo(rad, rad);
    ctx.arc(rad, rad, rad - 12, startAngle, startAngle + arc);
    ctx.lineTo(rad, rad);
    ctx.fillStyle = sector.color;
    ctx.fill();

    // Если у сектора есть текст
    if (sector.text) {
      ctx.save();
      ctx.translate(rad, rad);
      ctx.rotate(startAngle + arc / 2);

      ctx.textAlign = "right";
      ctx.textBaseline = "middle";

      const textRadius = rad - 25;
      const maxTextWidth = rad * 0.6; // Устанавливаем максимальную ширину текста
      let fontSize = Math.max(10, rad / 20); // Базовый размер шрифта

      // Настраиваем шрифт
      ctx.font = `bold ${fontSize}px 'Unbounded', sans-serif`;

      // Проверяем ширину текста и уменьшаем размер шрифта, если текст слишком длинный
      while (ctx.measureText(sector.text).width > maxTextWidth && fontSize > 8) {
        fontSize -= 1;
        ctx.font = `bold ${fontSize}px 'Unbounded', sans-serif`;
      }

      // Убираем свечение у текста
      ctx.shadowColor = "transparent";
      ctx.shadowBlur = 0;

      // Настраиваем цвет текста в зависимости от цвета сектора
      ctx.fillStyle = sector.color === "#FF0000" ? "#fff" : "#000";
      ctx.fillText(sector.text, textRadius, 0);

      ctx.restore();
    }
  });
  // Сияние в центре
  this.drawGlow(ctx, rad);

  // Обод
  ctx.beginPath();
  ctx.arc(rad, rad, rad - 1, 0, 2 * Math.PI);
  ctx.lineWidth = 24;
  ctx.strokeStyle = "#FFD700";
  ctx.stroke();

  // «Огоньки»
  const arcPerSector = (2 * Math.PI) / this.sectors.length;
  this.sparkles.forEach((sparkle, i) => {
    const angle = i * arcPerSector;
    this.drawSparkle(ctx, rad, angle, sparkle.opacity);
  });
},

    //------------------------------------------------------
    // «Огоньки» (sparkles)
    //------------------------------------------------------
    drawSparkle(ctx, rad, angle, opacity) {
      const sparkleRadius = rad - 6;
      const x = rad + sparkleRadius * Math.cos(angle);
      const y = rad + sparkleRadius * Math.sin(angle);
      const sparkleSize = 20;

      const gradient = ctx.createRadialGradient(x, y, 1, x, y, sparkleSize);
      gradient.addColorStop(0, `rgba(255, 255, 255, ${opacity * 2})`);
      gradient.addColorStop(0.5, `rgba(255, 255, 200, ${opacity * 0.7})`);
      gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

      ctx.beginPath();
      ctx.arc(x, y, sparkleSize, 0, 2 * Math.PI);
      ctx.fillStyle = gradient;
      ctx.fill();
    },

    //------------------------------------------------------
    // Сияние в центре
    //------------------------------------------------------
    drawGlow(ctx, rad) {
      const glowGradient = ctx.createRadialGradient(
        rad, rad,
        this.glowRadius / 2,
        rad, rad,
        this.glowRadius
      );
      glowGradient.addColorStop(0, "rgba(255, 255, 255, 0.5)");
      glowGradient.addColorStop(1, "rgba(255, 255, 255, 0)");

      ctx.beginPath();
      ctx.arc(rad, rad, rad - 12, 0, 2 * Math.PI);
      ctx.fillStyle = glowGradient;
      ctx.fill();
    },

    //------------------------------------------------------
    // Анимация «пульсации» свечения
    //------------------------------------------------------
    animateGlow() {
      const step = 0.3;
      if (this.glowIncreasing) {
        this.glowRadius += step;
        if (this.glowRadius >= 40) this.glowIncreasing = false;
      } else {
        this.glowRadius -= step;
        if (this.glowRadius <= 30) this.glowIncreasing = true;
      }
      this.drawWheel();
      requestAnimationFrame(this.animateGlow);
    },

    //------------------------------------------------------
    // Анимация «огоньков»
    //------------------------------------------------------
    animateSparkles() {
      const step = 0.03;
      this.sparkles = this.sparkles.map((sparkle) => {
        if (sparkle.increasing) {
          sparkle.opacity += step;
          if (sparkle.opacity >= 1) sparkle.increasing = false;
        } else {
          sparkle.opacity -= step;
          if (sparkle.opacity <= 0.2) sparkle.increasing = true;
        }
        return sparkle;
      });
      this.drawWheel();
      requestAnimationFrame(this.animateSparkles);
    },

    async spinRoulette() {
      if (this.spinning) return;
      this.spinning = true;

      const melodiaAudio = new Audio(require('@/assets/melodia.mp3'));
      melodiaAudio.loop = true;

      try {
        const response = await fetch("https://ctvpnkoleso.ru/spin", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Add any required authorization headers
            // "Authorization": "Bearer your-token-here"
          },
          body: JSON.stringify({ user_id: this.userId })
        });

        if (!response.ok) {
          throw new Error("Ошибка на сервере. Попробуйте позже.");
        }

        const data = await response.json();
        const sectorLabel = data.sector;
        const prizeName = data.prize;
        const showSupport = data.showSupport;
        const showFireworks = data.showFireworks;
        const successMusic = data.successMusic;

        if (!sectorLabel) {
          this.spinning = false;
          this.showModalWithText("Извините, призов больше нет.");
          return;
        }

        melodiaAudio.play().catch((err) => {
          console.error("Ошибка воспроизведения melodia.mp3:", err);
        });

        const targetSector = this.sectors.findIndex((s) => s.label === sectorLabel);
        if (targetSector === -1) {
          throw new Error("Неверный сектор. Проверьте данные сервера.");
        }

        this.animateSpin(targetSector, () => {
          this.spinning = false;
          melodiaAudio.pause();
          melodiaAudio.currentTime = 0;
          const textForModal = prizeName
            ? `${prizeName}`
            : "Вам выпал пустой сектор!";
          this.showModalWithText(textForModal, showSupport, showFireworks, successMusic);
        });
      } catch (error) {
        console.error("Ошибка в spinRoulette:", error);
        this.showModalWithText("Произошла ошибка. Попробуйте позже.");
        this.spinning = false;
      }
    },

    animateSpin(targetSector, callback) {
      const totalRotations = 8;
      const sectorAngle = 360 / this.sectors.length;
      const finalRotation =
        (totalRotations * 360) +
        (90 - sectorAngle * (targetSector - 0.5));

      const canvas = this.$refs.wheel;
      const circleEl = document.querySelector(".central-circle");
      const drumEl = this.$refs.drumImage;

      // Удаляем классы анимации
      canvas.classList.remove('wheel-spinning');
      circleEl.classList.remove('circle-spinning');
      drumEl.classList.remove('drum-spinning');

      // Форсируем перерисовку
      void canvas.offsetWidth;
      void circleEl.offsetWidth;
      void drumEl.offsetWidth;

      document.documentElement.style.setProperty('--final-rotation', `${finalRotation}deg`);

      // Добавляем классы для запуска анимации
      canvas.classList.add('wheel-spinning');
      circleEl.classList.add('circle-spinning');
      drumEl.classList.add('drum-spinning');

      let currentRotation = 0;
      let lastSector = 0;
      const sectorsCount = this.sectors.length;

      const clickInterval = setInterval(() => {
        currentRotation += 10;
        const currentSector = Math.floor((currentRotation / (360/sectorsCount)) % sectorsCount);

        if (currentSector !== lastSector && this.clickSound) {
          this.clickSound.currentTime = 0;
          this.clickSound.play().catch(() => {});
          lastSector = currentSector;
        }

        if (currentRotation >= finalRotation) {
          clearInterval(clickInterval);
        }
      }, 100);

      // Обновляем обработчик окончания анимации
      const handleAnimationEnd = () => {
        canvas.style.transform = `rotate(${finalRotation}deg)`;
        circleEl.style.transform = `translate(-50%, -50%) rotate(${-finalRotation}deg)`;
        drumEl.style.transform = `rotate(${finalRotation}deg)`;

        canvas.classList.remove('wheel-spinning');
        circleEl.classList.remove('circle-spinning');
        drumEl.classList.remove('drum-spinning');

        canvas.removeEventListener('animationend', handleAnimationEnd);

        if (callback) callback();
      };

      canvas.addEventListener('animationend', handleAnimationEnd);
    },

    getRandomPrize(array) {
      const randomIndex = Math.floor(Math.random() * array.length);
      return array[randomIndex];
    },

    async collectPrize() {
      if (this.actionTaken) return;
      this.actionTaken = true;
      this.isShaking = true;

      try {
        const response = await fetch('https://ctvpnkoleso.ru/priz_no');
        const data = await response.json();
        this.selectedPrize = data.prize;
      } catch (err) {
        console.error('Error fetching prize:', err);
        this.selectedPrize = 'Ошибка получения приза';
      }

      await new Promise(resolve => setTimeout(resolve, 820));
      this.isShaking = false;
      await new Promise(resolve => setTimeout(resolve, 100));
      this.isOpenPrize = true;
      this.showCollectMessage = true;
      this.selectedVpn = null;
      // Using <br> for line breaks
      this.selectedPrize = `Вы получаете 1.000₽<br>В призе было: ${this.selectedPrize}`;
    },

    async handlePrizeClick() {
      if (this.isOpenPrize || this.actionTaken) return;
      this.actionTaken = true;
      this.isShaking = true;

      try {
        const response = await fetch('https://ctvpnkoleso.ru/priz_yes');
        const data = await response.json();
        this.selectedVpn = data.prize;
      } catch (err) {
        console.error('Error fetching VPN prize:', err);
        this.selectedVpn = 'Ошибка получения приза';
      }

      await new Promise(resolve => setTimeout(resolve, 820));
      this.isShaking = false;
      await new Promise(resolve => setTimeout(resolve, 100));
      this.isOpenPrize = true;
      this.selectedPrize = null;
      // Using <br> for line breaks
      this.selectedVpn = `Вам выпал ${this.selectedVpn}<br>Приз успешно начислен!`;
    },

    async selectCase(index) {
      if (this.caseSelected) return;
      this.caseSelected = true;

      // Запускаем анимацию тряски
      this.boxes[index].isShaking = true;

      await new Promise(resolve => setTimeout(resolve, 820));
      this.boxes[index].isShaking = false;

      await new Promise(resolve => setTimeout(resolve, 100));

      // Открываем шкатулку
      this.boxes[index].isOpen = true;

      // Ждем немного, чтобы case_lose.png успел отобразиться
      await new Promise(resolve => setTimeout(resolve, 300));

      // Только после отображения case_lose показываем текст
      this.showEmptyText = true;
    },

    closeCaseModal() {
      this.showCaseModal = false;
      this.boxes.forEach(box => {
        box.isOpen = false;
        box.isShaking = false;
      });
      this.caseSelected = false;
      this.showEmptyText = false; // сбрасываем состояние текста
    },
  },
};
</script>

<style>
/* Обновляем стили для body и app */
body {
  margin: 0;
  padding: 0;
  min-height: 100vh;
  background: url('@/assets/background.webp') no-repeat center center;
  background-size: cover;
}

/* Остальные стили остаются без изменений */
.wheel-spinning {
  animation: wheelSpin 12s cubic-bezier(0.3, 0, 0.2, 1) forwards;
  will-change: transform;
  backface-visibility: hidden;
  transform-style: preserve-3d;
  perspective: 1000px;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
}

.circle-spinning {
  animation: circleSpin 12s cubic-bezier(0.3, 0, 0.2, 1) forwards;
  will-change: transform;
  backface-visibility: hidden;
  transform-style: preserve-3d;
  perspective: 1000px;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
}

.drum-spinning {
  animation: drumSpin 12s cubic-bezier(0.3, 0, 0.2, 1) forwards;
  will-change: transform;
  backface-visibility: hidden;
  transform-style: preserve-3d;
  perspective: 1000px;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
}
/* Ваши стили из примера */
@import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Unbounded:wght@400;700&display=swap');

.roulette-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.title-image {
  max-width: 90%;
  height: auto;
  display: block;
  margin: 0 auto;
  margin-top: -20px; /* Поднимаем изображение выше */
}

#spin_the_wheel {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90%;
  max-width: 1000px;
}

canvas {
  display: block;
  border-radius: 50%;
  background: radial-gradient(circle, #006400 0%, #00AA00 100%);
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.5);
}

.central-circle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 18vw;
  height: 18vw;
  max-width: 200px;
  max-height: 200px;
  background: url('@/assets/circle.webp') no-repeat center center;
  background-size: contain;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.2);
  z-index: 3;
}

.pointer {
  position: absolute;
  top: 36%;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 21px solid transparent;
  border-right: 21px solid transparent;
  border-bottom: 40px solid #FFD700;
  z-index: 2;
}

.lenta-wrapper {
  position: relative;
  margin-top: 40px; /* Увеличиваем отступ сверху */
  width: 100%;
  max-width: 600px;
}

.lenta-image {
  width: 100%;
  height: auto;
  display: block;
}

.overlay {
  position: absolute;
  bottom: 20%; /* Опускаем текст ниже */
  left: 50%;
  transform: translate(-50%, 0);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: fit-content;
}

.vrash-label {
  font-family: 'Oswald', sans-serif;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  text-transform: uppercase;
}

.vrash-count {
  font-family: 'Oswald', sans-serif;
  font-size: 24px;
  font-weight: bold;
  color: #ffd700;
}

.animated-arrow {
  position: absolute;
  top: 25%;
  left: 50%;
  transform: translate(-50%, 0) rotate(180deg);
  width: 50px;
  height: auto;
  animation: bounce 1.5s infinite;
  z-index: 2;
}

@keyframes bounce {
  0%, 100% {
    transform: translate(-50%, 0) rotate(180deg);
  }
  50% {
    transform: translate(-50%, -10px) rotate(180deg);
  }
}

.modal {
  position: fixed;
  bottom: -100%; /* Скрыто по умолчанию */
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  max-width: 400px;
  background: #fff;
  box-shadow: 0px -4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 20px;
  z-index: 1000;
  animation: slide-up 0.4s ease forwards;
}
@keyframes slide-up {
  from {
    bottom: -100%;
  }
  to {
    bottom: 20%;
  }
}
.modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.8);
  width: 90%;
  max-width: 400px;
  background: #ffffff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  padding: 20px;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.4s ease, transform 0.4s ease, visibility 0.4s;
}

.modal.show {
  opacity: 1;
  visibility: visible;
  transform: translate(-50%, -50%) scale(1);
}

.modal.hide {
  opacity: 0;
  visibility: hidden;
  transform: translate(-50%, -50%) scale(0.8);
}

.modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  font-size: 20px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
}

.close-btn:hover {
  color: #ff0000;
}

.modal-message {
  font-size: 20px;
  text-align: center;
  color: #333;
  font-family: 'Oswald', sans-serif;
  font-weight: bold;
  line-height: 1.5;
  width: 100%;
  margin: 20px 0;
}

.contact-btn {
  width: 130px;
  margin-top: auto;
}

.exchange-btn {
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  font-family: 'Oswald', sans-serif;
}

.exchange-btn:hover {
  background-color: #45a049;
}
@media (max-height: 700px) {
  div[style*="position: fixed"] {
    bottom: 10px !important;
  }
  .modal-message {
  font-size: 14px;
}
}

#fireworks-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  pointer-events: none;
  z-index: 9999;
}

.firework-rocket {
  position: absolute;
  bottom: 0;
  width: 8px;
  height: 8px;
  transform: translateX(0);
  pointer-events: none;
}

.firework-rocket-inner {
  width: 100%;
  height: 100%;
  border-radius: 100%;
}

.firework-spark {
  position: absolute;
  width: 4px;
  height: 4px;
  border-radius: 2px;
  pointer-events: none;
  opacity: 0.8;
}

.firework-fragment {
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 3px;
  opacity: 0.9;
  pointer-events: none;
}

/* Добавляем стили для нового изображения */
.title-image {
  max-width: 90%;
  height: auto;
  display: block;
  margin: 0 auto;
  margin-top: 20px; /* Поднимаем изображение выше */
}

/* Удаляем неиспользуемые стили */
.golden-frame,
.golden-title {
  display: none;
}

/* Новые стили для счетчика вращений */
.spins-counter {
  position: relative;
  width: 300px; /* Фиксированная ширина */
  margin: 20px auto;
}

.spins-bg {
  width: 100%;
  height: auto;
  display: block;
}

.spins-overlay {
  position: absolute;
  bottom: 35%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: fit-content;
}

/* Добавляем стили для наложения барабана */
.drum-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none; /* Чтобы изображение не мешало кликам */
  z-index: 1; /* Поверх колеса, но под стрелкой и кнопкой */
}

/* Обновляем z-index для других элементов */
.animated-arrow, .pointer {
  z-index: 2;
}

.central-circle {
  z-index: 3;
}

.spinning {
  will-change: transform;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform-style: flat;
  transform-style: flat;
  -webkit-perspective: 1000;
  perspective: 1000;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}

#wheel {
  transition: transform 0.1s linear;
}

.central-circle {
  transition: transform 0.1s linear;
}

@keyframes wheelSpin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(var(--final-rotation));
  }
}

@keyframes circleSpin {
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  to {
    transform: translate(-50%, -50%) rotate(calc(-1 * var(--final-rotation)));
  }
}

#wheel, .central-circle {
  transform-origin: center center;
  -webkit-transform-origin: center center;
}

.central-circle {
  transform: translate(-50%, -50%) rotate(0deg);
}

/* Отключаем анимацию для устройств, предпочитающих уменьшенное движение */
@media (prefers-reduced-motion: reduce) {
  .wheel-spinning, .circle-spinning {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

.drum-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none; /* Чтобы изображение не мешало кликам */
}

.drum-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  position: absolute;
  top: 0;
  left: 0;
}

/* Обновляем анимацию для барабана */
@keyframes drumSpin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(var(--final-rotation));
  }
}

.drum-spinning {
  animation: drumSpin 12s cubic-bezier(0.3, 0, 0.2, 1) forwards;
  will-change: transform;
  backface-visibility: hidden;
  transform-style: preserve-3d;
  perspective: 1000px;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
}

/* Обновляем z-index для правильного наложения элементов */
#wheel {
  z-index: 1;
}

.drum-container {
  z-index: 2;
}

.animated-arrow,
.pointer {
  z-index: 3;
}

.central-circle {
  z-index: 4;
}

.prize-container {
  text-align: center;
  margin: 15px 0;
}

.prize-image {
  max-width: 150px; /* Уменьшили размер в 2 раза */
  height: auto;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.prize-image:hover {
  transform: scale(1.05); /* Легкое увеличение при наведении */
}

.prize-image.shake {
  animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
}

.prize-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  width: 100%;
  flex-direction: row-reverse;
  padding: 10px 0;
}

.prize-btn,
.collect-btn {
  flex: 1;
  max-width: 180px;
  min-width: 160px;
  padding: 15px 30px;
  border: none;
  border-radius: 25px;
  font-family: 'Oswald', sans-serif;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.prize-btn {
  background: linear-gradient(45deg, #4CAF50, #45a049);
  color: white;
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
}

.prize-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4);
  background: linear-gradient(45deg, #45a049, #4CAF50);
}

.prize-btn:active {
  transform: translateY(1px);
  box-shadow: 0 2px 10px rgba(76, 175, 80, 0.3);
}

.collect-btn {
  background: linear-gradient(45deg, #2196F3, #1e88e5);
  color: white;
  box-shadow: 0 4px 15px rgba(33, 150, 243, 0.3);
}

.collect-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(33, 150, 243, 0.4);
  background: linear-gradient(45deg, #1e88e5, #2196F3);
}

.collect-btn:active {
  transform: translateY(1px);
  box-shadow: 0 2px 10px rgba(33, 150, 243, 0.3);
}

.prize-btn:disabled,
.collect-btn:disabled {
  background: #cccccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.modal.prize-modal {
  min-height: 400px;
}

.modal.prize-modal .modal-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 450px;
  max-height: 80vh;
  padding: 30px 20px;
  box-sizing: border-box;
  overflow-y: auto;
}

.prize-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  gap: 15px;
  margin: 10px 0;
}

.prize-message {
  font-family: 'Oswald', sans-serif;
  font-size: 22px;
  font-weight: bold;
  margin: 0;
  text-align: center;
  line-height: 1.3;
  padding: 0 10px;
}

.prize-message.success {
  color: #4CAF50;
}

.prize-message.collect {
  color: #2196F3;
}

.buttons-container {
  margin-top: auto;
  padding: 15px 0;
}

.contact-support-btn,
.contact-btn {
  width: 200px;
  padding: 15px 30px;
  margin-top: 20px;
  border: none;
  border-radius: 25px;
  background: linear-gradient(45deg, #FF6B6B, #FF8E53);
  color: white;
  font-family: 'Oswald', sans-serif;
  font-size: 18px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3);
}

.contact-support-btn:hover,
.contact-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 107, 107, 0.4);
  background: linear-gradient(45deg, #FF8E53, #FF6B6B);
}

.contact-support-btn:active,
.contact-btn:active {
  transform: translateY(1px);
  box-shadow: 0 2px 10px rgba(255, 107, 107, 0.3);
}

.prize-buttons {
  margin-bottom: 10px;
}

.prize-btn,
.collect-btn,
.contact-support-btn,
.contact-btn {
  padding: 10px 0;
  font-size: 15px;
}

.case-modal {
  background: white !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.case-title {
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
  font-family: 'Unbounded', sans-serif;
  font-weight: 700;
  font-size: 28px;
  color: #2196F3;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.case-title.empty-case {
  color: #FF5722;
}

.cases-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
}

.case-box {
  width: 100px;
  height: 100px;
  background: #fff;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.case-box:hover {
  transform: scale(1.05);
}

.case-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.case-modal {
  background: white !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.case-title {
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
}

.cases-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin: 20px 0;
  width: 100%;
  flex-wrap: nowrap;
}

.case-box {
  cursor: pointer;
}

.case-box.shake {
  animation: caseShake 0.82s cubic-bezier(.36,.07,.19,.97) both;
}

@keyframes caseShake {
  10%, 90% { transform: translate3d(-2px, 0, 0) rotate(-3deg); }
  20%, 80% { transform: translate3d(4px, 0, 0) rotate(3deg); }
  30%, 50%, 70% { transform: translate3d(-8px, 0, 0) rotate(-3deg); }
  40%, 60% { transform: translate3d(8px, 0, 0) rotate(3deg); }
}

@media (max-width: 480px) {
  .cases-container {
    gap: 10px;
  }

  .case-image {
    width: 80px;
  }

  .case-title {
    font-size: 24px;
    margin-bottom: 20px;
  }
}

.prize-images-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin: 15px 0;
}

.prize-image, .additional-prize-image {
  max-width: 150px;
  height: auto;
}

.additional-prize-image {
  opacity: 0;
  animation: fadeIn 0.3s forwards;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.case-modal {
  background: white !important;
}

.cases-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin: 20px 0;
}

.case-box {
  cursor: pointer;
}

.case-box.shake {
  animation: caseShake 0.82s cubic-bezier(.36,.07,.19,.97) both;
}

@keyframes caseShake {
  10%, 90% { transform: translate3d(-2px, 0, 0) rotate(-3deg); }
  20%, 80% { transform: translate3d(4px, 0, 0) rotate(3deg); }
  30%, 50%, 70% { transform: translate3d(-8px, 0, 0) rotate(-3deg); }
  40%, 60% { transform: translate3d(8px, 0, 0) rotate(3deg); }
}

.case-subtitle {
  font-family: 'Unbounded', sans-serif;
  font-size: 18px;
  color: #333;
  margin: 0 0 20px 0;
  text-align: center;
}

.win-text {
  font-family: 'Unbounded', sans-serif;
  font-weight: 700;
  font-size: 24px;
  color: #4CAF50;
  margin: 20px 0 0 0;
  text-align: center;
  animation: fadeIn 0.5s ease-in;
}
</style>
